var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
export var View = function (_a) {
    var urls = _a.urls, alt = _a.alt, className = _a.className, onLoad = _a.onLoad, onError = _a.onError;
    return (React.createElement(PictureStyled, null,
        React.createElement("source", { srcSet: urls.webp, type: "image/webp" }),
        React.createElement("source", { srcSet: urls.jpeg, type: "image/jpeg" }),
        React.createElement("img", { src: urls.jpeg, alt: alt, className: className, onError: onError, onLoad: onLoad })));
};
var PictureStyled = styled.picture(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  img {\n    max-width: 100%;\n    display: block;\n  }\n"], ["\n  img {\n    max-width: 100%;\n    display: block;\n  }\n"])));
var templateObject_1;
